import { LoyaltyProgramResultType } from '../../types';

export const BACKGROUND_COLORS: Record<LoyaltyProgramResultType, string> = {
  published: 'var(--unions-color-lp-dialog-background)',
  unpublished: 'var(--unions-color-lp-dialog-background)',
  added: 'var(--unions-color-lp-dialog-background)',
  deleted: 'var(--unions-color-text-07-12)',
  updated: 'var(--unions-color-lp-dialog-background)',
} as const;

export const ICON_COLORS: Record<LoyaltyProgramResultType, string> = {
  published: 'var(--tui-status-positive)',
  unpublished: 'var(--tui-status-positive)',
  added: 'var(--tui-status-positive)',
  deleted: 'var(--unions-color-text-07)',
  updated: 'var(--tui-status-positive)',
} as const;
